import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

import { Button, Icon, Label, Table } from "semantic-ui-react"

import { Till } from "../../models/till.model"

import { TillService, HelperService } from "../../services"

import { TillCreateForm, LoadingSpinner, ErrorMessage, NoData, Badge } from "../../components"

import { FeedbackMessage } from "../../constants"

export function SupervisorTillsPage() {

    const navigate = useNavigate()

    const [tills, setTills] = useState<Till[]>([])
    const [userRole, setUserRole] = useState<string>('')
    const [loadingTills, setLoadingTills] = useState(true)
    const [errorFetchingTills, setErrorFetchingTills] = useState(false)
    const [createModalVisible, setCreateModalVisible] = useState(false)

    useEffect(() => {

        setUserRole(HelperService.getRoleFromToken())

        TillService.getTills('sup')
            .then(data => setTills(data))
            .catch(err => {
                console.log(err)
                setErrorFetchingTills(true)

            })
            .finally(() => setLoadingTills(false))
    }, [])

    const addToList = (till: Till) => setTills([...tills, till])

    return <div>
        {loadingTills && <LoadingSpinner />}
        {errorFetchingTills && <ErrorMessage errorText={FeedbackMessage.TILL_FETCH_ERROR} />}
        {!loadingTills && !errorFetchingTills &&
            <div>
                <div className='headerRow'>
                    <div className='flex-center'>
                        <h3 className='mb-0 mr-25'><Label color='orange'>{tills.length}</Label> &nbsp; Caisses</h3>
                    </div>
                    {userRole === 'Superviseur' &&
                        <Button color="orange" className="size-16" onClick={() => setCreateModalVisible(true)}>
                            <Icon name="add circle" />Nouvelle caisse
                        </Button>
                    }
                </div>
                {
                    tills.length === 0 ? <NoData /> :
                        <Table basic="very">
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell className="size-17">N°</Table.HeaderCell>
                                    <Table.HeaderCell className="size-17">Caisse</Table.HeaderCell>
                                    <Table.HeaderCell className="size-17">Agence</Table.HeaderCell>
                                    <Table.HeaderCell className="size-17">État</Table.HeaderCell>
                                    <Table.HeaderCell className="size-17">Services</Table.HeaderCell>
                                    <Table.HeaderCell className="size-17">Assignation en cours</Table.HeaderCell>
                                    {/* <Table.HeaderCell className="size-17">Début</Table.HeaderCell>
                                <Table.HeaderCell className="size-17">Fin</Table.HeaderCell> */}
                                    <Table.HeaderCell className="size-17" textAlign='right'>Actions</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {tills.map(t => <Table.Row key={t.id}>
                                    <Table.Cell>{t.id}</Table.Cell>
                                    <Table.Cell>{t.name}</Table.Cell>
                                    <Table.Cell>{t.agencyName}</Table.Cell>
                                    <Table.Cell>
                                        <Badge type={t.state === 'OPEN' ? 'success' : 'error'}>{t.displayedState}</Badge>
                                    </Table.Cell>
                                    <Table.Cell>
                                        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                                            {t.services?.map(s => (
                                                <img
                                                    key={s}
                                                    src={HelperService.getLogoImageUrl(s)}
                                                    title={s}
                                                    alt={s}
                                                    style={{ width: '32px', height: '32px', borderRadius: '4px', background: 'white', border: '1px solid #eee' }}
                                                />
                                            ))}
                                        </div>
                                    </Table.Cell>
                                    <Table.Cell>
                                        {t.cashierFullname
                                            ? <>
                                                <div><b>{t.cashierFullname}</b></div>
                                                <div style={{ color: 'grey', fontSize: '0.85em' }}>
                                                    Du {HelperService.formatDate(t.assignationStart)} au {HelperService.formatDate(t.assignationEnd)}
                                                </div>
                                            </>
                                            : <span style={{ color: 'grey' }}></span>
                                        }
                                    </Table.Cell>
                                    {/* <Table.Cell>{HelperService.formatDate(t.assignationStart)}</Table.Cell>
                                <Table.Cell>{HelperService.formatDate(t.assignationEnd)}</Table.Cell> */}
                                    <Table.Cell textAlign='right'>
                                        <Button icon className='mr-10'><Icon name='trash alternate' /></Button>
                                        <Button icon className='mr-10'><Icon name='pencil alternate' /></Button>
                                        <Button onClick={() => navigate(`/${HelperService.getCompanyName()}/supervisor/tills/${t.id}/assignations`)}><Icon name='calendar alternate outline' /> Calendrier</Button>
                                    </Table.Cell>
                                </Table.Row>)}
                            </Table.Body>
                        </Table>
                }
            </div>
        }

        {createModalVisible && <TillCreateForm setCreateModalVisible={setCreateModalVisible} addTillToList={addToList} />}
    </div>

}
